export const EVENT_STATE = {
  NO_EVENT_STATE: 0,
  EVENT_STATE_FREE: 1,
  EVENT_STATE_FEW_PLACES: 2,
  EVENT_STATE_BOOKED_UP: 3,
  EVENT_STATE_BEGUN: 4,
  EVENT_STATE_CANCELED: 5,
  EVENT_STATE_COMPLETED: 6,
  EVENT_STATE_BOOKED_UP_NO_WAITLIST: 7,
}

export const EVENT_ONLINE_TYPE = {
  OFFLINE: 'offline',
  ONLINE: 'online',
  HYBRID: 'hybrid',
}
